import React from 'react';
import { styled } from 'linaria/react';
import BlogMenu from './BlogMenu';
import Head from '@jetshop/core/components/Head';
import { useLocation } from 'react-router';
import BlogItemList from './BlogItemList';
import CategoryHeader from '../CategoryPage/CategoryHeader';
import { ContentPadding } from '../Layout/Content/Content';
import { PagePadding } from '../Layout/MaxWidth';
import { useBlog } from './hook/useBlog';

const BlogPageWrapper = styled('div')`
  ${ContentPadding}
  min-height: 800px;
`;

const BlogPage = ({ configObject }) => {
  const location = useLocation();
  const { mainCategory, menuCategories, currentMenuCategory, articles } =
    useBlog({
      ...configObject,
      pathname: location.pathname,
    });

  function getBreadcrumbProps(category) {
    return {
      breadcrumbs: category.primaryRoute?.breadcrumbs,
      parents: category.primaryRoute?.parents,
    };
  }

  const breadcrumbProps = getBreadcrumbProps(currentMenuCategory);
  return (
    <BlogPageWrapper>
      {currentMenuCategory.head && (
        <Head
          data={currentMenuCategory}
          route={currentMenuCategory.primaryRoute}
        />
      )}
      <CategoryHeader
        category={mainCategory}
        breadcrumbProps={breadcrumbProps}
        standardCategory={true}
        showSubs={false}
      />
      <PagePadding>
        {menuCategories.length > 0 && (
          <BlogMenu
            categories={menuCategories}
            mainPath={mainCategory.primaryRoute.path}
            pathname={location.pathname}
          />
        )}
        <BlogItemList categories={articles} blogPage={true} />
      </PagePadding>
    </BlogPageWrapper>
  );
};

export default BlogPage;
